import axios from 'axios';
import Api from '../http.service';
import { isTripord } from '../../utils/consts/general';

/**
 * get all my ticket list
 * @param {Object} payload
 * @param {String} payload.selectedTab
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {Object} payload.data.filter
 * @param {String} payload.data.sort
 * @param {String} payload.data.order
 *
 */
export const getAll = (payload) =>
  Api.GET({
    url: `ticket/customer/${payload.selectedTab}?page=${
      payload.pageNumber - 1
    }&size=${payload.itemPerPage}&where=${payload.data.filter}&sort=${
      payload.data.sort
    }&order=${payload.data.order}`,
  });

/**
 * get all reply list
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data._id
 * @param {Boolean} payload.data.isOperator
 */
export const updateReply = (payload) =>
  Api.PUT({
    url: `ticket/read/${payload.pageNumber - 1}/${payload.itemPerPage}`,
    data: payload.data,
  });

/**
 * get all done ticket list
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data._id
 * @param {Boolean} payload.data.isOperator
 */
export const updateDoneTicket = (payload) =>
  Api.PUT({ url: 'ticket/customer/done', data: payload.data });

/**
 * send ticket
 * @param {Object} payload
 * @param {String} payload._id
 * @param {String} payload.attachment
 * @param {String} payload.message
 * @param {String} payload.subject
 */
export const replyTicket = (payload) =>
  Api.POST({ url: 'ticket/customer/reply', data: payload });

/** getStatistic
 */

export const getStatistic = (payload) =>
  Api.GET({ url: 'ticket/customer/statistic' });

/**create ticket
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data._id
 * @param {String} payload.data.attachment
 * @param {String} payload.data.message
 * @param {String} payload.data.subject
 */
export const createTicket = (payload) =>
  Api.POST({ url: 'ticket/customer/create', data: payload.data });

//TODO:check Api maybe need to  deleted
/**
 * send ticket for online support
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data._id
 * @param {String} payload.data.attachment
 * @param {String} payload.data.message
 * @param {String} payload.data.subject
 * @param {String} payload.data.bookingId
 */
export const createBookingTicket = (payload) =>
  Api.POST({ url: 'ticket/customer/create', data: payload.data });

/**
 * send ticket for online support
 * @param {Object} payload
 * @param {String} payload.languageName
 * @param {String} payload.id
 */
export const showTicket = ({ id, languageName }) => {
  return axios.get(
    `https://api.${
      isTripord ? 'tripord.com' : 'tripsi.ir'
    }/invoice/ticket/${languageName}/${id}`,
    {
      headers: {
        'Content-type': 'applcation/html',
        type: 'applcation/html',
      },
      responseType: 'arraybuffer',
    },
  );
};
